import { Stack, styled } from '@mui/material';

export const StackStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  gap: theme.spacing(4),
  padding: theme.spacing(4),
  borderRadius: theme.spacing(1),
}));
